var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceivedAtYourDoorstep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1433 10.5452L32.2773 10.5107L32.2221 35.943L48.088 35.9775L48.1433 10.5452Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0588 34.2558L38.0527 37.0557L41.086 37.0622L41.0921 34.2624L38.0588 34.2558Z",
    fill: "#170F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7346 38.7421L44.8333 38.7252L44.8881 35.69L46.7544 35.652L46.7314 11.6142L32.9628 11.6614L32.8691 35.7016L34.7354 35.6635L34.6806 38.6987L29.7792 38.6818L29.8659 8.57363L49.8213 8.63396L49.7346 38.7421Z",
    fill: "#170F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0092 49.1071V38.2436H14.8015V49.1071H8.59375V32.0359L22.5611 19.6309L36.5181 32.0359V49.1071H27.2169",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.111 50.7009H25.6231V47.504H34.9244V32.7503L22.5607 21.7626L10.197 32.7503V47.504H13.2077V36.6508H22.6021V50.7009H19.4154V39.8374H16.3943V50.7009H7V31.3225L22.5607 17.5L38.111 31.3225V50.7009Z",
    fill: "#170F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedAtYourDoorstep);
export default __webpack_public_path__ + "static/media/received-at-your-doorstep.678a2bbb5b5e6ac723dcd273eceaf2c8.svg";
export { ForwardRef as ReactComponent };